export const CANCEL_REASONS = [
    'Too Expensive',
    'Didn\'t Complete Setup',
    'Not Using It Enough',
    'Missing Features',
    'My Customers Didn\'t Like It',
    'Switched to Another Solution',
    'My Business Is Closing',
    'Other',
];
